import {User} from "@beeldit/user-and-access/users/models/User";

export class Customer {
    public id: number;
    public user: User;
    public alternative_email: string;
    public phone: string;
    public street: string;
    public city: string;
    public postal_code: string;
    public observations: string;
    public discount: number;
    public state: string;
    public country: string;
    public create_address: boolean;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;

    constructor() {
        this.id = 0;
        this.user = new User();
        this.alternative_email = '';
        this.phone = '';
        this.street = '';
        this.city = '';
        this.postal_code = '';
        this.observations = '';
        this.discount = 0;
        this.create_address = true;
        this.state = '';
        this.country = '';
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
    }
}
